import React from 'react';
import dynamic from 'next/dynamic';
import AdminProvider from './AdminProvider';
import AdminGuard from './AdminGuard';
import adminModule from './adminModule';
var AdminTools = dynamic(() => import(
/* webpackChunkName: "AdminTools" */
'./AdminTools'));
var LoggingAdminPanel = dynamic(() => import(
/* webpackChunkName: "AdminTools" */
'./LoggingAdminPanel'));
export default function adminExtension() {
  return registry => ({
    id: 'admin',
    server: process.browser ? undefined : {
      init() {
        require('./config');
      }

    },
    app: {
      render(props, children) {
        var panelsFromExtensions = [];
        registry.forEach(extension => {
          if (extension.admin && extension.admin.panels) {
            var panels = extension.admin.panels;

            if (typeof panels === 'function') {
              panels = panels(props);
            }

            panelsFromExtensions.push(panels);
          }
        });
        return /*#__PURE__*/React.createElement(AdminProvider, null, children, /*#__PURE__*/React.createElement(AdminGuard, null, panelsFromExtensions, /*#__PURE__*/React.createElement(LoggingAdminPanel, null)), /*#__PURE__*/React.createElement(AdminGuard, {
          mode: "once"
        }, /*#__PURE__*/React.createElement(AdminTools, null)));
      }

    },
    redux: {
      modules: [adminModule]
    }
  });
}